// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const seal = defineModel({
  id: "seal",
  scale: 2.41, // real-world size correction (see Model.scale)
  batchId: "future",
  name: "Seal",
  tags: ["creature","seal","low-poly","age-of-mcp","future","water"],
  summary: "A seal — polar-water fauna that basks on ice and shore.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.12,
  parts: () => [
      { geometry: new THREE.IcosahedronGeometry(0.055, 0), color: "#8b9099", position: [-0.01, 0.04, 0], scale: [2, 0.8, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.04, 0), color: "#b6bbc2", position: [-0.01, 0.028, 0], scale: [1.9, 0.5, 0.85] },
      { geometry: new THREE.IcosahedronGeometry(0.032, 0), color: "#9aa0a8", position: [0.075, 0.07, 0], scale: [1, 1.1, 0.95] },
      { geometry: new THREE.IcosahedronGeometry(0.018, 0), color: "#6f747c", position: [0.1, 0.062, 0], scale: [1.3, 0.9, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.004, 0), color: "#100c0a", position: [0.092, 0.082, 0.016] },
      { geometry: new THREE.IcosahedronGeometry(0.004, 0), color: "#100c0a", position: [0.092, 0.082, -0.016] },
      { geometry: new THREE.IcosahedronGeometry(0.004, 0), color: "#100c0a", position: [0.112, 0.06, 0] },
      { geometry: new THREE.CylinderGeometry(0.0008, 0.0008, 0.022, 3), color: "#dfe2e6", position: [0.11, 0.06, 0.012], rotation: [0, 0.5, 1.570796] },
      { geometry: new THREE.CylinderGeometry(0.0008, 0.0008, 0.022, 3), color: "#dfe2e6", position: [0.11, 0.06, -0.012], rotation: [0, -0.5, 1.570796] },
      { geometry: new THREE.BoxGeometry(0.05, 0.008, 0.022), color: "#8b9099", position: [0.03, 0.018, 0.04], rotation: [0.3, 0.5, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 0.008, 0.022), color: "#8b9099", position: [0.03, 0.018, -0.04], rotation: [-0.3, -0.5, 0] },
      { geometry: new THREE.ConeGeometry(0.026, 0.07, 5), color: "#8b9099", position: [-0.085, 0.04, 0], rotation: [0, 0, 1.570796], scale: [1, 1, 0.7] },
      { geometry: new THREE.BoxGeometry(0.018, 0.006, 0.05), color: "#9aa0a8", position: [-0.1, 0.035, 0], rotation: [0, 0, 0.2] },
    ],
  animations: [],
});
